import { render, staticRenderFns } from "./ListOptions.vue?vue&type=template&id=537045b7&scoped=true&"
import script from "./ListOptions.vue?vue&type=script&lang=ts&"
export * from "./ListOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537045b7",
  null
  
)

export default component.exports